import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'searchFilter'
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {
	transform(items: any[], filter: string, value: string): any[] {
		if ( !items || !filter || !value )
			return items;
		return items.filter( (item) => {
			var item = item[filter].toLowerCase();
				value = value.toLowerCase();
		 	return item.indexOf(value) !== -1;
		});
	}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/pipes/search.filter.pipe.ts